import type { AppRouteConfig } from '../../models'
import { FeatureIdEnum } from '../../enums'
import { Index } from '../../views'
import { ROUTER_CONSTS } from '../router.consts'

export const INDEX_ROUTES: Array<AppRouteConfig> = [
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.INDEX],
    path: 'index',
    component: Index,
    meta: {
      featureId: FeatureIdEnum.INDEX,
    },
  },
]
